import { useState } from "react";
import {
  Box,
  IconButton,
  Link,
  Popover,
  Tooltip,
  Typography,
} from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";

import { Stockpile } from "../../interface/api/Stockpile";
import { StockpileSample } from "../../interface/api/StockpileSample";
import storageAreaService from "../../services/storageAreaService";
import { history } from "../..";
import { formatDateTime } from "../../utils/date-helper";

const StockpileCell = ({ stockpile }: { stockpile?: Stockpile }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [sample, setSample] = useState<StockpileSample | null>(null);
  const [loading, setLoading] = useState(false);

  if (!stockpile) {
    return <span>—</span>;
  }

  const isClosed = stockpile.status === "Closed";

  const onOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
    setLoading(true);
    storageAreaService.getStockpileSample(stockpile.id).then((response) => {
      if (response.ok && response.data) {
        setSample(response.data as StockpileSample);
      }
      setLoading(false);
    });
  };

  const onClose = () => setAnchorEl(null);

  const goToScreen = () => history.push(`/stockpile-sampling/${stockpile.id}`);

  if (!isClosed) {
    return (
      <Link
        component="button"
        type="button"
        onClick={goToScreen}
        style={{ textAlign: "left" }}
      >
        {stockpile.name}
      </Link>
    );
  }

  return (
    <Box display="flex" alignItems="center" style={{ gap: 4 }}>
      <Box display="flex" flexDirection="column">
        <Link
          component="button"
          type="button"
          onClick={goToScreen}
          style={{ fontWeight: 600, textAlign: "left" }}
        >
          {stockpile.name}
        </Link>
        {stockpile.approvalDate && (
          <Typography variant="caption" color="textSecondary">
            Approved {formatDateTime(stockpile.approvalDate, true)}
          </Typography>
        )}
      </Box>
      <Tooltip title="View lab result">
        <IconButton size="small" color="primary" onClick={onOpen}>
          <DescriptionIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} style={{ minWidth: 220 }}>
          <Typography variant="subtitle2" gutterBottom>
            Lab Result — {stockpile.name}
          </Typography>
          {loading && <Typography variant="body2">Loading…</Typography>}
          {!loading && !sample?.labResultUrl && (
            <Typography variant="body2" color="textSecondary">
              No lab result.
            </Typography>
          )}
          {!loading && sample?.labResultUrl && (
            <Link
              href={sample.labResultUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              View lab result
            </Link>
          )}
        </Box>
      </Popover>
    </Box>
  );
};

export default StockpileCell;
